import script from "./ProfileTableLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileTableLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProfileTableLayout.vue?vue&type=style&index=0&id=604a3a42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-604a3a42"]])

export default __exports__